<button
  mat-icon-button
  matTooltip="Refresh jobs"
  class="border-common rounded-md h-[48px] w-[48px]"
  (click)="refreshJobs()"
  [attr.data-test]="'refresh-jobs-button'"
  [disabled]="state.isLoading"
>
  <fa-icon class="text-base text-gray-800" *ngIf="!state.isLoading" [icon]="['fal', 'arrow-rotate-right']"></fa-icon>
  <div class="h-full w-full aligner" *ngIf="state.isLoading">
    <mat-spinner [diameter]="25"></mat-spinner>
  </div>
</button>
